import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface MovieCardProps {
  movie: Movie;
  showSynopsis?: boolean;
}

export default function MovieCard({ movie, showSynopsis = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-0 w-full pb-[150%] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`《${movie.title}》${movie.genres.join("、")}海报`}
          title={`${movie.title} 秋霞影视`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/85 px-2 py-0.5 text-xs font-500 text-background-50">
          {movie.type}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-600 text-primary-950">
          <i className="ri-star-fill text-xs" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-600 text-foreground-950 group-hover:text-primary-700">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600">
          {movie.year} · {movie.region} · {movie.genres.join(" / ")}
        </p>
        {showSynopsis && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {movie.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}